
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[username]/toko-top-up",
      function () {
        return require("private-next-pages/[username]/toko-top-up/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[username]/toko-top-up"])
      });
    }
  